import PackageProcurementStep from '@/models/PackageProcurementStep';
import PackageProcurementStepService, { ProcurementStepRow } from '@/services/PackageProcurementStepService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const usePackageProcurementStepsStore = defineStore('packageProcurementSteps', {
  state: () => ({}),

  getters: {
    models: () => useRepo(PackageProcurementStep),
  },

  actions: {
    async index(projectId: Id, packageId: Id) {
      const [data, error] = await PackageProcurementStepService.index(projectId, packageId);

      if(error) {
        throw error;
      }

      this.models.where('package_id', packageId).delete();
      this.models.save(data.data);

      return data;
    },

    async update(projectId: Id, packageId: Id, steps: ProcurementStepRow[]) {
      const [data, error] = await PackageProcurementStepService.update(projectId, packageId, steps);

      if(error) {
        throw error;
      }

      this.models.where('package_id', packageId).delete();
      this.models.save(data.data);

      return data;
    },
  },
});
